import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

export default function Placeholders() {
    const { t } = useTranslation();

    return (
        <Container fluid className="bg-body-danger text-center">
            <Container>
                <Row className="py-4 gy-4">
                    <Col xs={6} sm={3}>
                        <i className="bi-box2 fs-1"></i>
                        <div>{t('placeholder.delivery')}</div>
                        <Link to={'/delivery'} className="btn btn-light d-block mx-auto mt-1">{t('placeholder.more')}</Link>
                    </Col>
                    <Col xs={6} sm={3}>
                        <i className="bi-chat-left-text fs-1"></i>
                        <div>{t('placeholder.help')}</div>
                        <Link to={'/help'} className="btn btn-light d-block mx-auto mt-1">{t('placeholder.more')}</Link>
                    </Col>
                    <Col xs={6} sm={3}>
                        <i className="bi-credit-card fs-1"></i>
                        <div>{t('placeholder.leasing')}</div>
                        <Link to={'/leasing'} className="btn btn-light d-block mx-auto mt-1">{t('placeholder.more')}</Link>
                    </Col>
                    <Col xs={6} sm={3}>
                        <i className="bi-fast-forward fs-1"></i>
                        <div>{t('placeholder.about')}</div>
                        <Link to={'/about-us'} className="btn btn-light d-block mx-auto mt-1">{t('placeholder.more')}</Link>
                    </Col>
                </Row>
            </Container>
        </Container >
    )
}